export default {
  BUReceiptList: {
    Title: 'Lập dự toán thu',

    BtnsYear: {
      Title: 'Đầu năm/ Bổ sung',
    },
    BtnsAdjust: {
      Title: 'Điều chỉnh',
    },
    BtnMLNS: 'Dự toán thu theo MLNS',
    BtnTT342: 'Dự toán thu theo NDKT TT342',
    BtnTT343: 'Dự toán thu theo NDKT TT343',
    BtnTT344: 'Dự toán thu theo NDKT TT344',
  },
  BUReceiptDetailCommon: {
    BeginYear: 'Đầu năm',
    Add: 'Bổ sung',
    Year: 'Năm',
    Description: 'Diễn giải',
    CTReference: 'CT tham chiếu',
    CTReferenceTooltip: 'Chứng từ tham chiếu',
    RefDate: 'Ngày CT',
    RefNo: 'Số CT',
    RefDateTooltip: 'Ngày chứng từ',
    RefNoTooltip: 'Số chứng từ',

    Allotment: 'Phân bổ',
    NoAllotment: 'Không phân bổ',
    Quarterly: 'Theo quý',
    Monthly: 'Theo tháng',

    PostedDate: 'Ngày HT',
    BeginTheYear: 'Đầu năm',
    Additional: 'Bổ sung',
    DecisionDay: 'Ngày QĐ',
    DecisionNumber: 'Số QĐ',
    PostedDateTooltip: 'Ngày hạch toán',
    DecisionNumberTooltip: 'Số quyết định',
    DecisionDayTooltip: 'Ngày quyết định',
    Title: {
      MLNS: 'Dự toán thu theo Mục lục ngân sách',
      MLNSAdjust: 'Điều chỉnh dự toán thu theo Mục lục ngân sách',
      TT342: 'Dự toán thu theo NDKT (Mẫu TT 342/2016/TT-BTC)',
      TT342Adjust: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 342/2016/TT-BTC)',
      TT343: 'Dự toán thu theo NDKT (Mẫu TT 343/2016/TT-BTC)',
      TT343Adjust: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 343/2016/TT-BTC)',
      TT344: 'Dự toán thu theo NDKT (Mẫu TT 344/2016/TT-BTC)',
      TT344Adjust: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    },
  },
  BUPopup: {
    UtilityPopup: {
      Title: 'Lập dự toán mới dựa vào dự toán năm',
      BudgetReceiptYear: 'Dự toán thu theo mục lục ngân sách năm {0}',
      BudgetExpenseYear: 'Dự toán chi theo mục lục ngân sách năm {0}',
    },
    MLNSPopup: {
      Title: 'Thông tin bổ sung',
    },
  },
};
